import React, { useContext, useEffect } from 'react';
import { ModalContext } from './ModalContext';

const GlobalModal = () => {
  const { modalContent, closeModal } = useContext(ModalContext);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeModal(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModal]);

  if (!modalContent) return null;

  if (!React.isValidElement(modalContent)) {
    console.error('modalContent is not a valid React element');
    return null;
  }

  return (
    <div style={overlayStyle}>
      <div>
        {React.cloneElement(modalContent, { closeModal })}
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

export default GlobalModal;
